import gql from 'graphql-tag';

import client from '../graphqlAPI';

// `rows` is a JSON-encoded array of `{ code, link, scope }` — the backend contract is
// locked (see task brief): the server caps a single call at 5,000 rows and REJECTS
// (rather than truncates) anything larger, so callers must chunk client-side. It also
// re-validates every row's scope against `scope` and rejects the whole call if that
// target scope sits outside the `loyalty-prize` namespace.
//
// Pattern copied from createEmailCampaign.js — the closest existing mutation wrapper in
// this folder (this is the first mutation added under LoyaltyComponents).
const IMPORT_TICKET_CODES_MUTATION = gql`
  mutation importTicketCodes($scope: String!, $rows: String!) {
    importTicketCodes(scope: $scope, rows: $rows) {
      isAuth
      inserted
      rejected
      errors
    }
  }
`;

const importTicketCodes = async ({ scope, rows }) => {
  try {
    const result = await client
      .mutate({
        mutation: IMPORT_TICKET_CODES_MUTATION,
        variables: { scope, rows },
        fetchPolicy: 'no-cache',
      })
      .then(mutationResult => mutationResult)
      .catch((mutationError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Mutation Error: ${mutationError}`);
        return null;
      });

    const { data: { importTicketCodes: importTicketCodesData } } = result;

    if (importTicketCodesData) return importTicketCodesData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: importTicketCodesData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: importTicketCodes Error: ${error}`);
    return null;
  }
};

export default importTicketCodes;
